import { render, staticRenderFns } from "./QuestionnaireViewSectionGroup.vue?vue&type=template&id=16f08670"
import script from "./QuestionnaireViewSectionGroup.vue?vue&type=script&lang=js"
export * from "./QuestionnaireViewSectionGroup.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireViewSectionGroup.vue?vue&type=style&index=0&id=16f08670&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports